import styled from 'styled-components';

import { MessageTypeEnum } from './helpers';

import { device, hexToRGB, typography } from '@/styles/helpers';

export const ScMessageContainer = styled.div<{ type: MessageTypeEnum }>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  background: ${({ theme, type }) => {
    const MAP_TYPE_TO_COLOR: Record<MessageTypeEnum, string> = {
      [MessageTypeEnum.Warning]: hexToRGB(theme.yellowColor, 0.2),
      [MessageTypeEnum.Info]: hexToRGB(theme.lightBlue, 0.2),
    };
    return MAP_TYPE_TO_COLOR[type];
  }};

  .icon {
    display: flex;
    width: 24px;
    height: 24px;
    margin-right: 16px;
  }

  .message {
    ${typography['body2regular']}
    color: ${({ theme }) => theme.whiteColor};

    @media (${device.mobile}) {
      color: ${({ theme }) => theme.whiteColor};
    }
  }
`;
